import { Component, computed } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UiModule } from '../../../../components/ui.module';
import { humanFileSize } from '../../../../helpers';
import { LocationCamera } from '../../../../types';

type CellParams = ICellRendererParams & { allCameras: () => Record<string, LocationCamera[]> };

@Component({
  selector: 'app-pan-cell-installer-dashboard-camera-provider-actions',
  imports: [UiModule, MatTooltipModule, RouterModule],
  templateUrl: './cell-installer-dashboard-location-cameras.component.html',
  styleUrl: './cell-installer-dashboard-location-cameras.component.scss',
})
export class CellInstallerDashboardLocationCamerasComponent implements ICellRendererAngularComp {
  public humanFileSize = humanFileSize;

  public params!: CellParams;

  public rowCameras = computed(() => this.params.allCameras()[this.params.data.id] ?? []);

  agInit(params: CellParams) {
    this.params = params;
  }

  refresh(params: CellParams) {
    this.params = params;
    return true;
  }
}
